import { SyncSpec as Spec } from 'bspec'

function getInventory(product) {
  if (product.PurchasableInventory && Object.keys(product.PurchasableInventory).length > 0)
    return product.PurchasableInventory
  else if (product.Inventory && Object.keys(product.Inventory).length > 0)
    return product.Inventory
  return {}
}

export const soldOutSpec = new Spec(({ product, date }) => {
  if (product) {
    const inventory = getInventory(product)
    const dateCount = !_.isEmpty(inventory) ? inventory[date] : null
    return dateCount !== null ? dateCount === 0 : false
  }

  return null
})

export const lowInventorySpec = new Spec(({ product, date, threshold = 11 }) => {
  if (product) {
    const inventory = getInventory(product)
    const dateCount = !_.isEmpty(inventory) ? inventory[date] : null
    if (dateCount === 0) {
      return null
    } else {
      return dateCount !== null ? dateCount <= threshold : null
    }
  }
  return null
})

export const noInventorySpec = new Spec(({ product, date, threshold = 1 }) => {
  if (product) {
    const inventory = getInventory(product)
    const dateCount = !_.isEmpty(inventory) ? inventory[date] : null
    return dateCount !== null ? dateCount < threshold : true
  }

  return null
})

export const lowPricingInventorySpec = new Spec(({ product, date, threshold = 10 }) => {
  if (product) {
    const datePriceCount = !_.isEmpty(product.PricingInventory) ? product.PricingInventory[date] : null
    return datePriceCount !== null ? datePriceCount < threshold : null
  }

  return null
})

export const noPricingInventorySpec = new Spec(({ product, date, threshold = 1 }) => {
  if (product) {
    const datePriceCount = !_.isEmpty(product.PricingInventory) ? product.PricingInventory[date] : null
    return datePriceCount !== null ? datePriceCount < threshold : null
  }

  return null
})

export const noActivityTimesSpec = new Spec(({ product, date, threshold = 0 }) => {
  if (product) {
    let hasActivityTimes = false
    if (product.ActivityTimes) {
      const activityTimes = !_.isEmpty(product.ActivityTimes) ? product.ActivityTimes[date] : null
      // eslint-disable-next-line no-extra-boolean-cast
      if (!!activityTimes) {
        const slotsWithInventory = activityTimes.filter((slot) => {
          return slot.AvailableInventory > threshold
        })
        hasActivityTimes = !_.isEmpty(slotsWithInventory)
      }
    }

    return !hasActivityTimes
  }

  return null
})
